import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { MultiDeviceInteractionState } from '../../models/consumer/consumer-interaction.model';
import { MultiDeviceInteractionService } from '../../services/multi-device-interaction.service';


@Component({
    selector: 'multi-device-interactions',
    templateUrl: './multi-device-interactions.component.html',
    styles: []
})
export class MultiDeviceInteractionsComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    state: MultiDeviceInteractionState;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private multiDeviceInteractionService: MultiDeviceInteractionService
    ) { }

    ngOnInit() {
        let queryParams = this.route.snapshot.queryParams;
        if (queryParams.state) {
            this.state = queryParams.state;
        }

        this.route.queryParams.subscribe(
            result => {
                if (result.state) {
                    this.state = result.state;
                }
            }
        );

        this.subscriptions.push(this.router.events.subscribe(
            event => {
                if (event instanceof NavigationStart) {
                    let urlParts = event.url.split('/');
                    let isNavigationAway = !urlParts.find(x => x.toLowerCase() == 'multideviceinteractions') &&
                        !urlParts.find(x => x.toLowerCase() == 'create');
                    if (isNavigationAway) {
                        window.sessionStorage.removeItem('multi-device-interaction');
                    }
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe());
    }
}
